import angular from 'angular';

import PrivacyPolicyModule from './privacy-policy';
import TermsOfServiceModule from './terms-of-service';

import { getPresentationStateUrl } from 'common';

export default angular
    .module('legal.scene', [
        PrivacyPolicyModule.name,
        TermsOfServiceModule.name
    ])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider
        .state('landing', {
            url: getPresentationStateUrl(),
            data: {
                external: {
                    blank: true
                }
            }
        });
}



// WEBPACK FOOTER //
// ./src/legal/scene/index.js